/**
 * 区域配色与 UI 主题色。
 *
 * 初始值是从设计稿 starbattle-package/Asset/sprite_purple/主玩.png 采样来的
 * （采样脚本已废弃删除）。现在这里就是配色的唯一出处，直接改本文件。
 *
 * 第 7 个区域色偏离了设计稿：采样值 #FF9CF2 与第 8 个 #EEA6C2 在棋盘上太难分辨，
 * 手动换成偏紫的 #DD80FB。
 */

/** 区域色，按 regionId - 1 取用，超出则回绕。 */
export const REGION_COLORS = [
    '#9578D7', '#B26B41', '#FFA764', '#CB618B',
    '#5C83B8', '#5BBEEA', '#DD80FB', '#EEA6C2',
    '#A4BEDB', '#A3DC8D', '#E6B835', '#33B6B1',
];

/**
 * 取区域色。regionId 从 1 起。
 * @param {number} regionId
 * @returns {string}
 */
export function regionColor(regionId) {
    const i = (regionId - 1) % REGION_COLORS.length;
    return REGION_COLORS[i < 0 ? i + REGION_COLORS.length : i];
}

/** UI 主题色。 */
export const THEME = {
    boardGap: '#EAE3D6',
    boardPanel: '#F8ECD7',
    btnPurple: '#4C1B9F',
    btnRed: '#E3232A',
    pageBottom: '#F9ECD7',
    pageTop: '#F2F3DC',
    progressFill: '#FCB42A',
    progressTrack: '#9E6340',
    redCross: '#D7452D',
    ruleActive: '#E07D6C',
    ruleIdle: '#E7DDD8',
    textBrown: '#6C422E',
};
